import HistoryModal from './HistoryModal';

export default HistoryModal;
